(function () {
  const PRODUCTS_KEY = 'roselin_product_list';
  const COLLECTION_KEY = 'roselin_collection_url';
  const COLLECTION_LABEL_KEY = 'roselin_collection_label';
  const COLLECTION_BASE_KEY = 'roselin_collection_base';
  let isFetching = false;

  function getProductLinks(doc) {
    const d = doc || document;
    return Array.from(d.querySelectorAll('a.product-card__link[href*="/products/"]'))
      .map(a => ({
        url: a.href.split('?')[0],
        label: a.getAttribute('aria-label') || ''
      }));
  }

  function getTotalPages() {
    const pageLinks = document.querySelectorAll('pagination-link[data-url*="?page="]');
    let max = 1;
    pageLinks.forEach(link => {
      const text = link.textContent.trim();
      if (text === '>' || text === '<') return;
      const match = (link.dataset.url || '').match(/[?&]page=(\d+)/);
      if (match) {
        const num = parseInt(match[1]);
        if (!isNaN(num) && num > max) max = num;
      }
    });
    return max;
  }

  function getCollectionBase() {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    const qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  async function saveAllProducts() {
    if (window.location.pathname.includes('/products/')) return;
    if (isFetching) return;

    const currentBase = getCollectionBase();
    const savedBase = sessionStorage.getItem(COLLECTION_BASE_KEY) || '';
    const existing = sessionStorage.getItem(PRODUCTS_KEY);

    // Si es la misma colección/filtro y ya tenemos productos, no refrescar
    if (existing && currentBase === savedBase) return;

    isFetching = true;

    const currentProducts = getProductLinks();
    if (!currentProducts.length) { isFetching = false; return; }

    // Guardar inmediatamente los productos visibles
    sessionStorage.setItem(PRODUCTS_KEY, JSON.stringify(currentProducts));
    sessionStorage.setItem(COLLECTION_KEY, window.location.origin + currentBase);
    sessionStorage.setItem(COLLECTION_BASE_KEY, currentBase);
    const h1 = document.querySelector('h1');
    if (h1) sessionStorage.setItem(COLLECTION_LABEL_KEY, h1.textContent.trim());

    const totalPages = getTotalPages();
    if (totalPages <= 1) { isFetching = false; return; }

    const baseUrl = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.delete('page');

    const fetches = [];
    for (let p = 2; p <= totalPages; p++) {
      const pageParams = new URLSearchParams(params);
      pageParams.set('page', p);
      fetches.push(
        fetch(`${baseUrl}?${pageParams.toString()}`)
          .then(r => r.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            return getProductLinks(doc);
          })
          .catch(() => [])
      );
    }

    const results = await Promise.all(fetches);
    const allProducts = currentProducts.concat(...results);

    const seen = new Set();
    const unique = allProducts.filter(p => {
      if (seen.has(p.url)) return false;
      seen.add(p.url);
      return true;
    });

    sessionStorage.setItem(PRODUCTS_KEY, JSON.stringify(unique));
    isFetching = false;
  }

  // ── EN LA COLECCIÓN ──────────────────────────────────────────────────────
  if (!window.location.pathname.includes('/products/')) {
    saveAllProducts();

    const observer = new MutationObserver(function () {
      if (!document.querySelector('a.product-card__link')) return;
      const currentBase = getCollectionBase();
      const savedBase = sessionStorage.getItem(COLLECTION_BASE_KEY) || '';
      if (currentBase !== savedBase) {
        saveAllProducts();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── EN EL PRODUCTO ───────────────────────────────────────────────────────
  if (!window.location.pathname.includes('/products/')) return;

  const saved = sessionStorage.getItem(PRODUCTS_KEY);
  if (!saved) return;

  const products = JSON.parse(saved);
  const currentUrl = window.location.pathname;
  const currentIndex = products.findIndex(p => {
    try { return new URL(p.url).pathname === currentUrl; } catch { return false; }
  });

  if (currentIndex === -1) return;

  const prev = products[currentIndex - 1] || null;
  const next = products[currentIndex + 1] || null;
  const collectionUrl = sessionStorage.getItem(COLLECTION_KEY) || '#';
  const collectionLabel = sessionStorage.getItem(COLLECTION_LABEL_KEY) || 'Colección';
  const total = products.length;
  const position = currentIndex + 1;

  const nav = document.createElement('nav');
  nav.className = 'roselin-product-nav';
  nav.setAttribute('aria-label', 'Navegación entre productos');
  nav.innerHTML = `
    <div class="roselin-product-nav__inner">
      <a class="roselin-product-nav__back" href="${collectionUrl}">
        ← ${collectionLabel}
      </a>
      <div class="roselin-product-nav__controls">
        <span class="roselin-product-nav__counter">${position} / ${total}</span>
        ${prev
          ? `<a class="roselin-product-nav__arrow" href="${prev.url}" title="${prev.label}">&#8592;</a>`
          : `<span class="roselin-product-nav__arrow disabled">&#8592;</span>`
        }
        ${next
          ? `<a class="roselin-product-nav__arrow" href="${next.url}" title="${next.label}">&#8594;</a>`
          : `<span class="roselin-product-nav__arrow disabled">&#8594;</span>`
        }
      </div>
    </div>
  `;

  const target = document.querySelector('main') || document.body;
  target.prepend(nav);

  const style = document.createElement('style');
  style.textContent = `
    .roselin-product-nav {
      width: 100%;
      background: #fff;
      border-bottom: 1px solid #e8e8e8;
      padding: 12px 24px;
      box-sizing: border-box;
    }
    .roselin-product-nav__inner {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .roselin-product-nav__back {
      font-size: 12px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #1a1a1a;
      text-decoration: none;
      padding: 10px 16px;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
    }
    .roselin-product-nav__back:hover { opacity: 0.5; }
    .roselin-product-nav__controls {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .roselin-product-nav__counter {
      font-size: 12px;
      letter-spacing: 0.08em;
      color: #999;
      margin-right: 8px;
    }
    .roselin-product-nav__arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      font-size: 20px;
      color: #1a1a1a;
      text-decoration: none;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
    }
    .roselin-product-nav__arrow:hover { background: #f5f5f5; }
    .roselin-product-nav__arrow.disabled {
      opacity: 0.2;
      pointer-events: none;
    }
  `;
  document.head.appendChild(style);
})();
